import { ArrowTopRightOnSquareIcon, ArrowUturnLeftIcon, ChevronRightIcon, XMarkIcon } from "@heroicons/react/24/outline";
import { DocumentIcon } from "@heroicons/react/24/solid";
import React from "react";

const VisaExchangeRateCalc: React.FC = () => {
  const linkItems = [
    { text: "What is online fraud?", icon: ChevronRightIcon, target: "what-is-online-fraud" },
    { text: "What is payment fraud?", icon: ChevronRightIcon, target: "what-is-payment-fraud" },
    { text: "What is APP fraud and how do I avoid it?", icon: ChevronRightIcon, target: "what-is-app-fraud-and-how-do-i-avoid-it" },
    { text: "What are the most common types of payment fraud?", icon: ChevronRightIcon, target: "what-are-the-most-common-types-of-payment-fraud" },
    { text: "What are the most common types of scams?", icon: ChevronRightIcon, target: "what-are-the-most-common-types-of-scams" },
    { text: "How can I protect myself from fraud?", icon: ChevronRightIcon, target: "how-can-i-protect-myself-from-fraud" },
    { text: "What is contactless card fraud, and how can I prevent it?", icon: ChevronRightIcon, target: "what-is-contactless-card-fraud-and-how-can-i-prevent-it" },
    { text: "What is phishing?", icon: ChevronRightIcon, target: "what-is-phishing" },
    { text: "What is two-Factor Authentication (2FA)?", icon: ChevronRightIcon, target: "what-is-two-factor-authentication-2fa" },
    { text: "What should I do if I suspect fraud on my account?", icon: ChevronRightIcon, target: "what-should-i-do-if-i-suspect-fraud-on-my-account" },
    { text: "What should I do if my card is lost or stolen?", icon: ChevronRightIcon, target: "what-should-i-do-if-my-card-is-lost-or-stolen" },
    { text: "What should I do if I am a victim of fraud or cybercrime?", icon: ChevronRightIcon, target: "what-should-i-do-if-i-am-a-victim-of-fraud-or-cybercrime" },
    { text: "Where can I find more information about fraud prevention?", icon: ChevronRightIcon, target: "where-can-i-find-more-information-about-fraud-prevention" },
  ];

  return (
    <div className="flex flex-col items-center container pt-20">
      {/* Header Section */}
      <header className="w-full px-5">
        <h1 className="text-4xl font-extrabold text-gray-900">VISA Exchange Rate Calculator</h1>
        <p className="mt-4 text-lg text-gray-700">Use the link below to get an indication of the rate you may receive when using your Visa card to pay while travelling internationally.  </p>
      </header>

      {/* Main Content Section */}
      <section className="w-full px-5 mt-8 p-6">
        <p className="text-gray-800">Please note that the “Bank fee” section is available to be edited to obtain accurate pricing. There is no Bank fee being charged and therefore this should be set to zero.</p>
        <div className="flex mt-4">
          <a
            href="https://www.visa.co.uk/support/consumer/travel-support/exchange-rate-calculator.html"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center text-blue-600 my-4 gap-1 nc-Button flex-shrink-0 relative h-auto justify-center rounded-full transition-colors border-transparent bg-transparent ring-1 ring-blue-600 hover:bg-transparent hover:text-blue-600 text-sm sm:text-base font-medium py-3 px-4 sm:px-6   "
          >
            <DocumentIcon className="w-4 h-4" />
            VISA Exchange Rate Calculator
          </a>
        </div>
      </section>
    </div>
  );
};

export default VisaExchangeRateCalc;
